module.exports = __webpack_public_path__ + "img/casa.8d2f9565.gif";